module.exports = __webpack_public_path__ + "static/media/leapingFrog.e6945592.png";